<template>
  <div>
    <v-container fluid>
      <div class="main">
        <v-row>
          <v-col cols="12">
            <div class="d-flex justify-space-between mb-3">
              <v-spacer/>

              <v-btn class="rounded-lg"
                     color="gifty"
                     dark
                     @click="$refs.createQuotaCIBDialog.open()"
                     depressed
              >
                <v-icon left>mdi-plus</v-icon>
                Ajouter un quota CIB
              </v-btn>
            </div>

            <v-card class="rounded-lg shadow">
              <v-overlay :value="overlay" absolute color="white" opacity="0.5">
                <v-progress-circular
                    color="primary"
                    indeterminate
                    size="50"
                ></v-progress-circular>
              </v-overlay>

              <v-card-title>
                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      clearable
                      dense
                      filled
                      hide-details
                      placeholder="Rechercher..."
                      rounded
                      single-line

                  />
                </div>
                <v-spacer/>

                <v-btn color="grey"
                       icon
                       @click="getQuotas">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>

              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>
                <v-card-text class="pa-0">

                  <v-data-table v-if="quotas.length"
                                :headers="headers"
                                :items="quotas"
                                :search="keyword"
                  >

                    <template v-slot:item.status="{ item }">
                      <v-switch v-model="item.is_active"
                                class="pa-0 ma-0"
                                color="success"
                                hide-details
                                readonly
                                @click="changeStatus(item.id)"></v-switch>

                    </template>


                    <template v-slot:item.user_verification_status="{ item }">

                      <v-icon left dense v-if="item.user_verification_status === 'verified'" color="success">
                        mdi-check-circle
                      </v-icon>

                      <v-icon left dense v-if="item.user_verification_status === 'unverified'" color="red">
                        mdi-close-circle
                      </v-icon>
                      <span>{{ getVerificationStatusLabel(item.user_verification_status) }}</span>
                    </template>


                    <template v-slot:item.actions="{ item }">
                      <v-btn icon @click="$refs.createQuotaCIBDialog.open(item)">
                        <v-icon>mdi-pencil-outline</v-icon>
                      </v-btn>
                      <v-btn icon @click="remove(item.id)">
                        <v-icon>mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>

                    <template v-slot:item.amount="{ item }">
                      <span class="font-weight-medium gifty--text">
                      {{ CurrencyFormatting(item.amount) }} DZD
                      </span>
                    </template>

                  </v-data-table>

                  <div v-else>
                    <NoResults @reload="getQuotas"/>
                  </div>

                </v-card-text>

              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <CreateQuotaCIBDialog ref="createQuotaCIBDialog" @refresh="getQuotas"/>

    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";
import CreateQuotaCIBDialog from "./components/CreateQuotaCIBDialog.vue";

export default {
  components: {CreateQuotaCIBDialog, NoResults},
  data() {
    return {
      id: '',
      keyword: '',
      overlay: false,
      isLoading: false,
      quotas: [],
      headers: [
        {
          text: 'Status',
          align: 'start',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Nom du quota',
          value: 'name',
        },
        {
          text: 'Statut vérification de l\'utilisateur',
          value: 'user_verification_status',
        },
        {
          text: 'Montant',
          value: 'amount',
        },
        {
          text: 'Créé le',
          value: 'created_at',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  methods: {
    getQuotas() {
      this.isLoading = true
      HTTP.get('/v1/quotas-cib').then(res => {
        this.quotas = res.data.data
        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    remove(id) {
      this.id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.post("/v1/quotas-cib/delete", {
        id: this.id,
      }).then(() => {
        this.overlay = false;
        let i = this.quotas.findIndex((el) => el.id === this.id);
        this.$delete(this.quotas, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    changeStatus(id) {
      this.overlay = true;
      HTTP.post("/v1/quotas-cib/change-status", {
        id: id,
      }).then(() => {
        this.overlay = false;
        let index = this.quotas.findIndex(el => el.id === id)
        this.quotas[index].is_active = !this.quotas[index].is_active
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
    getVerificationStatusLabel(status) {
      switch (status) {
        case 'verified':
          return 'Vérifié';
        case 'unverified':
          return 'Non vérifié';
        default:
          return '';
      }
    }
  },
  created() {
    this.getQuotas();
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    }
  }
};
</script>

<style scoped></style>
